module.exports = __webpack_public_path__ + "img/credit-card.f89e2122.png";